$(document).ready(function () {
    // enquiry pop up 
    var autofillDetails = function () {
        // Get deatils of the product
        var productName = $('.product__title h1').text();
        var productPrice = $('.tiles-calculator .tiles-box-result .tiles-total-price span#TotalPriceContainer').text()
        var SKUnumber = $('.product__sku .sku').text();
        var surfaceDetail = $('variant-selects fieldset input[name="Surface"]').val();
        var productSize = $('variant-selects fieldset input[name="Size"]').val()
        var projectLength = $('.tiles-calculator .tile-length').val();
        var projectWidth = $('.tiles-calculator .tile-width').val();
        var SQMneeded = $('.tiles-calculator .tiles-input input').val();
        var SQMneeded2 = $('.tiles-calculator .subtotal-tile-area').val();
        var productQTY = $('.product-sheet-template .quantity__input').val();
        // Auto fill to form fields
        $('form .field input#ContactForm-product-name').val(productName);
        $('form .field input#ContactForm-product-price').val(productPrice);
        $('form .field input#ContactForm-product-qty').val(productQTY);
        if (SKUnumber == '') {
            $('form .field input#ContactForm-product-SKU').val('SKU is not available for this product');
        } else {
            $('form .field input#ContactForm-product-SKU').val(SKUnumber);
        }
        $('form .field input#ContactForm-product-surface').val(surfaceDetail);
        $('form .field input#ContactForm-product-size').val(productSize);
        if (projectLength == '') {
            $('form .field input#ContactForm-project-length').val('Project length is not provided');
        } else {
            $('form .field input#ContactForm-project-length').val(projectLength);
        }

        if (projectWidth == '') {
            $('form .field input#ContactForm-project-width').val('Project width is not provided');
        } else {
            $('form .field input#ContactForm-project-width').val(projectWidth);
        }
   
        if ((SQMneeded == '') && (SQMneeded2 == '')) {
            $('form .field input#ContactForm-project-width').val('Project width is not provided');
        } else if (SQMneeded2 !== '') {
            $('form .field input#ContactForm-product-SQM').val(SQMneeded2);
        } else {
            $('form .field input#ContactForm-product-SQM').val(SQMneeded);
        }
    }

    // enquiry pop up 
    $(document).on("click", "#inquiryBtn", function () {
        autofillDetails();
        $('#enquiryPopup').css('display', 'flex');
    });
    $(document).on("click", ".close", function () {
        $('#enquiryPopup').hide();
    });

    var findIDinURL = window.location.href.indexOf("contact_form") > -1
    if (findIDinURL == true) {
        autofillDetails();
        $('#enquiryPopup').css('display', 'flex');
    } else {
        $('#enquiryPopup').hide();
    }

   // enquiry pop up  2
    var autofillDetailstwo = function () {
        // Get deatils of the product
        var productName = $('.product__title h1').text();
        // Auto fill to form fields
        $('form .field input#ContactForm-product-name').val(productName);
       
    }

   // enquiry pop up 2 
    $(document).on("click", "#inquiryBtn1", function () {
       autofillDetailstwo();
        $('#enquiryPopup1').css('display', 'flex');
    });
    $(document).on("click", ".close", function () {
        $('#enquiryPopup1').hide();
    });

    var findIDinURL = window.location.href.indexOf("contact_form") > -1
    if (findIDinURL == true) {
        autofillDetailstwo();
        $('#enquiryPopup1').css('display', 'flex');
    } else {
        $('#enquiryPopup1').hide();
    }

    // hiding sample product from the site 
    $('ul.product-grid li a').each(function() {
        if ($(this).text().includes('Sample')) {        
            $(this).closest('li').addClass('d-none');    
            $('body').addClass('sample-d-none');    
        }
    });

    // Preventing enquiry form to reload page
    $('#ContactForm').on('submit', function(event) {         
      event.preventDefault(); 
      let isValid = true;
      $(".error-message").remove();
      
      const name = $('#ContactForm-name').val().trim();
      const email = $('#ContactForm-email').val().trim();
    
      if (!name) {
          isValid = false;
          $('#ContactForm-name').after('<span class="error-message" style="display: block;">Name is required.</span>');
      }
    
      if (!email) {
          isValid = false;
          $('#ContactForm-email').after('<span class="error-message" style="display: block;">Email is required.</span>'); 
      } else if (email !== "" && !validateEmail(email)) {
          isValid = false;
          $("#ContactForm-email").after('<span class="error-message" style="display: block;">Please enter a valid email address.</span>');
      }
    
      if (!isValid) {
          return false;
      }
    
      $.ajax({
          type: 'POST',
          url: '/contact#ContactForm', 
          data: $('#ContactForm').serialize(),
          success: function(response) {
              const dom = $(response);
              dom.find('#enquiryPopup').css('display', 'flex');
              $('html').html(dom);
          },
          error: function() {
              console.log('An error occurred. Please try again.'); 
          }
      });
    });
    
    function validateEmail(email) {
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }
    
    $('#ContactForm #ContactForm-name, #ContactForm #ContactForm-email').on('input change', function() {
      $(this).next('.error-message').remove();
    });

  
 $('.collection .rich-text__text.rte').each(function() {
        if ($.trim($(this).text()) === '') {
            $(this).closest('.rich-text.content-container').hide();
        }
    });
});



//  Js for Multicoloum


(function () {

  function moveMulticolumnMobile() {
    if (window.innerWidth > 989) return;

    const productSection = document.querySelector('section[id^="MainProduct"]');
    const productGrid = productSection?.querySelector('.product');
    const productInfo = productSection?.querySelector('.product__info-wrapper');
    const multicolumn = document.querySelector('div.multicolumn');

    if (!productGrid || !productInfo || !multicolumn) return;

    if (!multicolumn.dataset.moved) {
      productGrid.insertBefore(multicolumn, productInfo);
      multicolumn.dataset.moved = "true";
    }
  }

  document.addEventListener('DOMContentLoaded', moveMulticolumnMobile);
  document.addEventListener('shopify:section:load', moveMulticolumnMobile);
  window.addEventListener('resize', moveMulticolumnMobile);

})();

